import React from 'react';
import Switch from 'react-ios-switch'

function Switcher(props) {
    return (
        <div onClick={props.onChangeHandler} className="side-bar-by-theme-item">
            <div>{props.header}</div>
            <Switch checked={props.checked} onChange={props.onChangeHandler} />
        </div>
    );
}

export default Switcher;